require("./myProfileModifyConsentView.scss");

// @vendors
const React = require("react");
const { withRouter } = require('react-router-dom');
const PropTypes = require("prop-types");
const { connect } = require("react-redux");

// @ actions
const profile = require("actions/profile");
const profileEditorActions = require("actions/profileEditor");
const retailLoanActions = require("ok-loans/src/actions/contractRetailLoan");

// @commons
const { formatText, FormattedText } = require("core/i18n").i18n;
const { OKCover } = require("commonsComponents/OKCover");
const { OKHeaderSubPage } = require("commonsComponents/OKHeaderSubPage");
const OKSwitch = require("gdpr-consents/components/OKSwitch/OKSwitch");
const { CallMeBack } = require("components/callMeBack/callMeBack");
const { ContentBox } = require("commonsComponents/contentBox");
const { LoadingSection } = require("commonsComponents/loadingSection");

// @components
const MyProfileModifyConsentViewConfirm = require("./myProfileModifyConsentViewConfirm/myProfileModifyConsentViewConfirm");

// @constants
const {
    RETAIL_LOAN_CONSENTS_ID,
    RETAIL_LOAN_CONSENTS_STATUS,
    retailLoanDoTaggin: {
        TAGGING_MODIFY_CONSENT,
        TAGGING_SWITCH,
        TAGGING_CANCEL,
        TAGGING_CONFIRM,
    },
} = require("ok-loans/src/loansConstants/index");
const { AMAZON_GIFT_CARD } = require('constants/flagBasedFeatures');

//@utils
const {
    recordLinkV2,
    recordProcess,
    PROC_START,
    PROC_END,
    PROC_FAIL,
} = require("../../../utilities/tagging");

class MyProfileModifyConsentView extends React.Component {
    state = {
        initialInterstitialConsentValue: null,
        actualInterstitialConsentValue: null,
        initialAmazonConsentValue: null,
        actualAmazonConsentValue: null,
        showConfirmScreen: false,
        hasUpdatedStatus: false,
        hasErrorConsentsStatus: false,
        hasErrorUpdatingStatus: false,
    };

    componentDidMount() {
        const { getConsentStatus } = this.props;
        getConsentStatus();
    }

    componentDidUpdate(_, prevState) {
        const {
            immRetailLoan,
            profileUpdateConsentStatusError,
            profileUpdateConsentStatusSuccess,
        } = this.props;
        const {
            hasUpdatedStatus,
            hasErrorConsentsStatus: hasErrorConsent,
        } = prevState;

        const interstitialConsentStatus = immRetailLoan.get(
            "acceptInterstitialConsentsStatus"
        );
        const amazonConsentStatus = immRetailLoan.get(
            "acceptAmazonConsentsStatus"
        );
        const hasErrorConsentsStatus = immRetailLoan.get(
            "hasErrorConsentsStatus"
        );
        const hasErrorUpdatingStatus = immRetailLoan.get(
            "hasErrorUpdatingUser"
        );
        const hasUpdatedUserConsent = immRetailLoan.get(
            "hasUpdatedUserConsent"
        );

        const errorConsentsUpdateDescription = immRetailLoan.get(
            "errorConsentsUpdateDescription"
        );

        const receivedInterstitialConsentStatus =
            this.state.initialInterstitialConsentValue === null && interstitialConsentStatus !== null;
        const receivedAmazonConsentsStatus =
            this.state.initialAmazonConsentValue === null && amazonConsentStatus !== null;
        if (receivedInterstitialConsentStatus || receivedAmazonConsentsStatus) {
            this.setState({
                initialInterstitialConsentValue: interstitialConsentStatus,
                actualInterstitialConsentValue: interstitialConsentStatus,
                initialAmazonConsentValue: amazonConsentStatus,
                actualAmazonConsentValue: amazonConsentStatus
            });
            recordProcess(
                TAGGING_MODIFY_CONSENT,
                PROC_START,
                {
                    nombrePagina: this.pageNameBuilder(PROC_START),
                },
                true
            );
        }

        if (
            hasUpdatedUserConsent &&
            !hasUpdatedStatus &&
            !this.state.showConfirmScreen
        ) {
            this.setState({
                hasErrorConsentsStatus,
                actualInterstitialConsentValue: interstitialConsentStatus,
                actualAmazonConsentValue: amazonConsentStatus,
                showConfirmScreen: true,
                hasUpdatedStatus: true,
                hasErrorUpdatingStatus,
            });

            const detalleProceso = this.getConsentDetalleProceso();
            recordProcess(
                TAGGING_MODIFY_CONSENT,
                PROC_END,
                {
                    nombrePagina: this.pageNameBuilder(PROC_END),
                    detalleProceso
                },
                true
            );
            if (interstitialConsentStatus) {
                profileUpdateConsentStatusSuccess({ status: interstitialConsentStatus });
            }
        } else if (hasErrorUpdatingStatus && !this.state.showConfirmScreen) {
            this.setState({
                hasErrorUpdatingStatus,
                hasErrorConsentsStatus,
                actualInterstitialConsentValue: interstitialConsentStatus,
                showConfirmScreen: true,
            });
            profileUpdateConsentStatusError({
                error: errorConsentsUpdateDescription,
                status: interstitialConsentStatus,
            });
            recordProcess(
                TAGGING_MODIFY_CONSENT,
                PROC_FAIL,
                { nombrePagina: this.pageNameBuilder(PROC_FAIL) },
                true
            );
        }

        if (
            hasErrorConsentsStatus &&
            !hasErrorConsent &&
            !this.state.showConfirmScreen
        ) {
            this.setState({
                showConfirmScreen: true,
                hasErrorConsentsStatus: true,
            });
            recordProcess(
                TAGGING_MODIFY_CONSENT,
                PROC_FAIL,
                { nombrePagina: this.pageNameBuilder(PROC_FAIL) },
                true
            );
        }
    }

    componentWillUnmount() {
        const { reset, resetErrorStatus } = this.props;
        resetErrorStatus();
        reset();
    }

    getConsentDetalleProceso() {
        const {
            actualAmazonConsentValue,
            actualInterstitialConsentValue,
            initialAmazonConsentValue,
            initialInterstitialConsentValue
        } = this.state;

        const isInterstitialStatusChanged = actualInterstitialConsentValue !== initialInterstitialConsentValue;
        const isAmazonStatuschanged = actualAmazonConsentValue !== initialAmazonConsentValue;
        const interstitialStatus = isInterstitialStatusChanged ? this.statusBuilder(actualInterstitialConsentValue) : '';
        const amazonStatus = isAmazonStatuschanged ? `gift ${this.statusBuilder(actualAmazonConsentValue)}` : '';
        const seperator = (isInterstitialStatusChanged && isAmazonStatuschanged) ? ', ' : '';

        return `${interstitialStatus}${seperator}${amazonStatus}`
    }

    keyBuilder(context, term) {
        return `${context}-${context}_${term}`;
    }

    statusBuilder = (status) => {
        return status === RETAIL_LOAN_CONSENTS_STATUS.ACCEPTED ? "si" : "no";
    };

    pageNameBuilder = (proc) => {
        return `${TAGGING_MODIFY_CONSENT}/${proc}`;
    };

    handleCancel = () => {
        const categoriaEvento = this.pageNameBuilder(PROC_START);
        const buildData = {
            categoriaEvento,
            accionEvento: TAGGING_CANCEL,
        };
        recordLinkV2(buildData);
        this.props.history.push("/myprofile/edit");
    };

    handleConfirm = () => {
        const { updateUserConsent, profileUpdateConsentStatus } = this.props;
        const {
            actualAmazonConsentValue,
            actualInterstitialConsentValue,
            initialAmazonConsentValue,
            initialInterstitialConsentValue
        } = this.state;

        this.setState({
            hasUpdatedStatus: false,
            hasErrorUpdatingStatus: false,
            showConfirmScreen: false,
        });

        const consents = [];
        const etiquetaEvento = this.getConsentDetalleProceso();
        const buildData = {
            etiquetaEvento,
            categoriaEvento: this.pageNameBuilder(PROC_START),
            accionEvento: TAGGING_CONFIRM,
        };
        recordLinkV2(buildData);

        if (actualInterstitialConsentValue !== initialInterstitialConsentValue) {
            consents.push({
                consentCellId: RETAIL_LOAN_CONSENTS_ID.INTERSTITIAL_CONSENT_ID,
                status: actualInterstitialConsentValue
            })
        }

        if (actualAmazonConsentValue !== initialAmazonConsentValue) {
            consents.push({
                consentCellId: RETAIL_LOAN_CONSENTS_ID.AMAZON_CONSENT_ID,
                status: actualAmazonConsentValue
            })
        }

        updateUserConsent(consents);
        profileUpdateConsentStatus({ status: actualInterstitialConsentValue });
    };

    buildLastDescription() {
        const splitMessage = formatText(
            this.keyBuilder("openMarketModifyConsent", "formBody")
        ).split("%s");

        const injectedLinks = [
            {
                text: this.keyBuilder(
                    "openMarketModifyConsent",
                    "formBoldDescription1"
                ),
            },
            {
                text: this.keyBuilder(
                    "openMarketModifyConsent",
                    "formBoldDescription2"
                ),
            },
        ];

        const messages = splitMessage.map((message, index) => {
            const link = injectedLinks[index];
            const boldText = link ? formatText(link.text) : "";
            const replacement = (
                <span className="modify-consent__content__body__description--bold">
                    {boldText}
                </span>
            );

            return (
                <span key={index}>
                    {message}
                    {replacement}
                </span>
            );
        });

        return (
            <div className="modify-consent__content__body__description">
                <p>{messages}</p>
            </div>
        );
    }

    sendEventModifyStatus = (checkValue, consentSwitch = '') => {
        const giftConstant = consentSwitch === 'amazonConsentSwitch' ? 'gift ' : '';
        const buildData = {
            etiquetaEvento: `${giftConstant}${this.statusBuilder(checkValue)}`,
            categoriaEvento: this.pageNameBuilder(PROC_START),
            accionEvento: TAGGING_SWITCH,
        };
        recordLinkV2(buildData);
    };

    buildContent() {
        const {
            actualAmazonConsentValue,
            actualInterstitialConsentValue,
            initialAmazonConsentValue,
            initialInterstitialConsentValue
        } = this.state;
        const { immFlagBasedFeatures, immRetailLoan } = this.props;
        const amazonEnableFlag = immFlagBasedFeatures.get(AMAZON_GIFT_CARD);
        const rightSection = this.buildRightSection();
        const isButtonDisabled = actualInterstitialConsentValue === initialInterstitialConsentValue && actualAmazonConsentValue === initialAmazonConsentValue;
        const isFetching = immRetailLoan.get("isUpdatingUserConsent");

        if (isFetching) {
            return <LoadingSection />;
        }

        return (
            <React.Fragment>
                <div className="col-xs-12 col-md-8">
                    <ContentBox
                        title={formatText(
                            "openMarketModifyConsent-openMarketModifyConsent_contentTitle"
                        )}
                        titleSeparator={true}
                    >
                        <p className="ok-section-box__paragraph">
                            <FormattedText value="openMarketModifyConsent-openMarketModifyConsent_contentBody" />
                        </p>

                        <div className="modify-consent">
                            <div className="modify-consent__header"></div>

                            <div className="modify-consent__content">
                                <div className="modify-consent__content__switch">
                                    <OKSwitch
                                        onChange={(e) => {
                                            this.setState({
                                                actualInterstitialConsentValue: e,
                                            });
                                            this.sendEventModifyStatus(e);
                                        }}
                                        positiveValue={
                                            RETAIL_LOAN_CONSENTS_STATUS.ACCEPTED
                                        }
                                        negativeValue={
                                            RETAIL_LOAN_CONSENTS_STATUS.NOT_ACCEPTED
                                        }
                                        neutralValue={
                                            RETAIL_LOAN_CONSENTS_STATUS.PENDING
                                        }
                                        value={actualInterstitialConsentValue}
                                    />
                                </div>

                                <div className="modify-consent__content__body">
                                    <h3 className="modify-consent__content__body__title">
                                        <FormattedText value="openMarketModifyConsent-openMarketModifyConsent_formTitle" />
                                    </h3>

                                    {this.buildLastDescription()}
                                </div>
                            </div>
                            {amazonEnableFlag && <div className="modify-consent__content">
                                <div className="modify-consent__content__switch">
                                    <OKSwitch
                                        onChange={(e) => {
                                            this.setState({
                                                actualAmazonConsentValue: e,
                                            });
                                            this.sendEventModifyStatus(e, "amazonConsentSwitch");
                                        }}
                                        positiveValue={
                                            RETAIL_LOAN_CONSENTS_STATUS.ACCEPTED
                                        }
                                        negativeValue={
                                            RETAIL_LOAN_CONSENTS_STATUS.NOT_ACCEPTED
                                        }
                                        neutralValue={
                                            RETAIL_LOAN_CONSENTS_STATUS.PENDING
                                        }
                                        value={actualAmazonConsentValue}
                                    />
                                </div>

                                <div className="modify-consent__content__body">
                                    <h3 className="modify-consent__content__body__title">
                                        <FormattedText value="openMarketModifyConsent-openMarketModifyConsent_amazonConsentTitle" />
                                    </h3>
                                    <div className="modify-consent__content__body__description">
                                        <FormattedText value="openMarketModifyConsent-openMarketModifyConsent_amazonConsentBody" />
                                    </div>
                                </div>
                            </div>}
                        </div>

                        <div className="ok-section-box__footer">
                            <footer className="wizard-step__buttons">
                                <div className="wizard-step__first-button">
                                    <button
                                        type="button"
                                        className="buttons-base buttons-base--regular buttons-base--link-ghost"
                                        onClick={() => this.handleCancel()}
                                    >
                                        <div>
                                            <div>
                                                <span className="buttons-base__children">
                                                    <FormattedText
                                                        value="buttonsActions-cancel"
                                                        format="firstUppercase"
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                    </button>
                                </div>
                                <div className="wizard-step__third-button">
                                    <button
                                        type="button"
                                        className="buttons-base buttons-base--regular buttons-base--primary"
                                        disabled={isButtonDisabled}
                                        onClick={this.handleConfirm}
                                    >
                                        <div>
                                            <div>
                                                <span className="buttons-base__children">
                                                    <FormattedText value="openMarketModifyConsent-openMarketModifyConsent_confirmButton" />
                                                </span>
                                            </div>
                                        </div>
                                    </button>
                                </div>
                            </footer>
                        </div>
                    </ContentBox>
                </div>
                {rightSection}
            </React.Fragment>
        );
    }

    buildRightSection() {
        return (
            <div className="col-xs-12 col-md-4">
                <div className="row">
                    <div className="col-md-12 grid-view--variable-cell-separation">
                        <div className="contact-info-box">
                            <div className="contact-info-box__text">
                                <h1 className="contact-info-box__text--header">
                                    <FormattedText value="openMarketModifyConsent-openMarketModifyConsent_rightSectionTitle" />
                                </h1>
                                <ul className="contact-info-box__text--body">
                                    <li>
                                        <FormattedText value="openMarketModifyConsent-openMarketModifyConsent_rightSectionBody" />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 grid-view--fix-cell-separation">
                        <section>
                            <CallMeBack pageTitle="Modificación de consentimiento" hasEntrance={false}/>
                        </section>
                    </div>
                </div>
            </div>
        );
    }

    buildCover(mappingBreadcrumb) {
        return (
            <div className="container-fluid">
                <div className="row">
                    <OKCover size="medium" section="pg" customClass="col-xs-12">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={formatText(
                                "openMarketModifyConsent-openMarketModifyConsent_headerTitle"
                            )}
                        />
                    </OKCover>
                </div>
            </div>
        );
    }

    render() {
        const { immRetailLoan } = this.props;
        const {
            actualAmazonConsentValue,
            actualInterstitialConsentValue,
            initialInterstitialConsentValue,
            initialAmazonConsentValue,
            hasErrorConsentsStatus,
            hasErrorUpdatingStatus,
            showConfirmScreen,
        } = this.state;

        const mappingBreadcrumb = [
            {
                text: formatText("breadcrumb-personalInformation"),
                url: "/myprofile/edit",
            },
            {
                text: formatText(
                    "openMarketModifyConsent-openMarketModifyConsent_breadcrumbTitle"
                ),
                url: "/myprofile/edit/consent/",
            },
            {
                text: formatText(
                    "openMarketModifyConsent-openMarketModifyConsent_breadcrumbSubtitle"
                ),
                url: "",
            },
        ];

        const content = this.buildContent();
        const cover = this.buildCover(mappingBreadcrumb);
        const isFetching = immRetailLoan.get("isFetchingStatusConsent");

        const errorMessage = hasErrorConsentsStatus
            ? formatText(
                  "openMarketInterstitialGetStatusErrorModal-openMarketInterstitialGetStatusErrorModal_modalDescription"
              )
            : formatText(
                  "openMarketModifyConsentConfirm-openMarketModifyConsentConfirm_messageError"
              );

        const interstitialStatus = actualInterstitialConsentValue !== initialInterstitialConsentValue && actualInterstitialConsentValue;
        const amazonStatus = actualAmazonConsentValue !== initialAmazonConsentValue && actualAmazonConsentValue;
        const hasError = hasErrorUpdatingStatus || hasErrorConsentsStatus;

        return (
            <React.Fragment>
                {cover}
                {showConfirmScreen ? (
                    <MyProfileModifyConsentViewConfirm
                        interstitialStatus={interstitialStatus}
                        amazonStatus={amazonStatus}
                        hasError={hasError}
                        errorMessage={errorMessage}
                        pageNameBuilder={this.pageNameBuilder}
                    />
                ) : (
                    <div className="grid-view__body ">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                {isFetching ? <LoadingSection /> : content}
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

MyProfileModifyConsentView.propTypes = {
    history: PropTypes.object.isRequired,
    immFiocDocumentation: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    immRetailLoan: PropTypes.object.isRequired,
    immProfileEditor: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    requestProfile: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    updateUserConsent: PropTypes.func.isRequired,
    getConsentStatus: PropTypes.func.isRequired,
    resetErrorStatus: PropTypes.func.isRequired,
    profileUpdateConsentStatus: PropTypes.func.isRequired,
    profileUpdateConsentStatusError: PropTypes.func.isRequired,
    profileUpdateConsentStatusSuccess: PropTypes.func.isRequired,
};

module.exports.constructor = MyProfileModifyConsentView;

module.exports.MyProfileModifyConsentView = connect(
    (state) => ({
        immRetailLoan: state.contractRetailLoan,
        immFiocDocumentation: state.fiocDocumentation,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immProfileEditor: state.profileEditor,
        immProfileFields: state.profile,
    }),
    {
        requestProfile: profile.requestProfile,
        reset: profileEditorActions.reset,
        updateUserConsent: retailLoanActions.updateUserConsent,
        getConsentStatus: retailLoanActions.getConsentStatus,
        profileUpdateConsentStatus: profile.profileUpdateConsentStatus,
        profileUpdateConsentStatusError:
            profile.profileUpdateConsentStatusError,
        profileUpdateConsentStatusSuccess:
            profile.profileUpdateConsentStatusSuccess,
        resetErrorStatus:
            retailLoanActions.simpleActions.retailLoanResetErrorsStatus,
    }
)(withRouter(MyProfileModifyConsentView));

